import styled, { css } from 'styled-components';
import { themeGet, getTextColor } from '@magalu/stereo-ui-styles';
import Text from '../../atoms/Text';
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const byType = {
  normal: css`
    font-size: ${props => themeGet('fontSizes.2')(props)}px;
  `,
  big: css`
    font-size: ${props => themeGet('fontSizes.4')(props)}px;
    font-weight: ${props => themeGet('fontWeights.bold')(props)};
  `
};
export const Title = styled(Text)`
  color: ${props => getTextColor('base')(props)};
  margin-bottom: 5px;

  ${props => byType[props.type]}
`;